import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom'
import { Breadcrumb } from 'antd';

import appRs from '../../App.reducer'

import './index.less'

class AppBreadcrumb extends Component {
    render() {
        const { location, appRs: { breadcrumb } } = this.props
        if (location.pathname === '/login') {
            return null
        }
        let last = breadcrumb.slice(-1)[0]
        if (!last) {
            return null
        }
        return <div className="breadcrumb-wrap">
            <Breadcrumb>
                {
                    breadcrumb.map(item => <Breadcrumb.Item key={item.name}>
                        {
                            (() => {
                                switch (typeof item.pathname) {
                                    case 'function':
                                        return <a onClick={item.pathname}>{item.name}</a>
                                    case 'string':
                                        return <Link to={item.pathname}>{item.name}</Link>
                                    case undefined:
                                    default:
                                        return item.name
                                }
                            })()
                        }
                    </Breadcrumb.Item>)
                }
            </Breadcrumb>
            <div className="last">
                <div className="name">
                    {
                        last.name
                    }
                </div>
                {last.desc && <div className="desc">
                    {
                        last.desc
                    }
                </div>}
            </div>
        </div>
    }
}

export default withRouter(connect(appRs)(AppBreadcrumb))


// WEBPACK FOOTER //
// ./src/components/AppBreadcrumb/index.jsx